import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { useEffect } from 'react';
import { Tag as TagIcon } from 'react-feather';
import { useBooleanState } from 'react-use-object-state';
import useEntityDrawer from '../useEntityDrawer';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    icon: {
      display: 'flex',
    },
  })
);

interface Props {
  name: string;
  value: boolean;
  tag?: boolean;
}

const EntityMenuItemQuickEdit = ({ name, value, tag }: Props) => {
  const loading = useBooleanState(false);
  const optimisticValue = useBooleanState(value);
  const classes = useStyles();
  const {
    entity: { updateEntity },
  } = useEntityDrawer();
  const handleToggle = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (loading.state) return;
    loading.setTrue();
    optimisticValue.toggle();
    try {
      await updateEntity(new Date().getTime(), { [name]: !value });
    } finally {
      loading.setFalse();
    }
  };

  useEffect(() => {
    optimisticValue.setState(value);
  }, [value]);

  return (
    <MenuItem onClick={handleToggle} disabled={loading.state}>
      <FormControlLabel
        control={<Switch color="primary" checked={optimisticValue.state} />}
        label={
          tag ? (
            <span className={classes.icon}>
              <TagIcon /> {name.replace('tag.', '')}
            </span>
          ) : (
            name
          )
        }
      />
    </MenuItem>
  );
};

export default EntityMenuItemQuickEdit;
